export const checkboxLaraThemeConfig = {
  colorScheme: {
    light: {
      background: "white",
      checkedBackground: "{primary.600}",
      borderColor: "{gray.300}",
      checkedBorderColor: "{primary.600}",
      iconCheckedColor: "white",
      iconSmSize: "8px",
      iconLgSize: "10px",
      disabledBackground: "{gray.50}",
      iconDisabledColor: "{gray.300}",
    },
  },
  sm: {
    width: "16px",
    height: "16px",
  },
  lg: {
    width: "20px",
    height: "20px",
  },
  css: ({ dt }: any) => `
    .p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus) .p-checkbox-box {
      outline: 2px solid white;
      box-shadow: 0px 0px 0px 4px #9E77ED, 0px 0px 0px 2px #FFFFFF;
    }
    .p-checkbox-sm .p-checkbox-box {
      border-radius: var(--radius-4);
    }
    .p-checkbox-lg .p-checkbox-box {
      border-radius: var(--radius-6);
    }
  `,
};
